import {FormEvent, useState} from "react";
import {AxiosError} from "axios";
import {NetworkCalls} from "../../NetworkCalls";
import {NetworkErrorHandling} from "../../components/NetworkErrorHandling";

export default function OrganisationManagement() {
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | undefined>(undefined);
  const [success, setSuccess] = useState<string | undefined>(undefined);
  const [formData, setFormData] = useState({
    organisationName: "",
    email: "",
    street: "",
    zipcode: "",
    city: "",
    country: "DE",
    state: "DE-NI",
    telephoneNumber: ""
  });

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setError(undefined);
    setSuccess(undefined);
    setSaving(true);
    try {
      await NetworkCalls.addOrganisation(formData);
      setSuccess("Verein angelegt.");
      setFormData({
        organisationName: "",
        email: "",
        street: "",
        zipcode: "",
        city: "",
        country: "DE",
        state: "DE-NI",
        telephoneNumber: ""
      });
    } catch (err) {
      NetworkErrorHandling.handle(err as AxiosError);
      setError("Speichern fehlgeschlagen.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="container-xl">
      <div className="page-header d-print-none">
        <h2 className="page-title">Vereine verwalten</h2>
      </div>
      <div className="card">
        <div className="card-body">
          <h3 className="mb-4">Neuen Verein anlegen</h3>
          <form onSubmit={handleSubmit} autoComplete="off" noValidate>
            {error ? <div className="text-danger mb-3">{error}</div> : null}
            {success ? (
              <div className="text-success mb-3">{success}</div>
            ) : null}
            <div className="mb-3">
              <label className="form-label text-dark">Vereinsname</label>
              <input
                type="text"
                className="form-control"
                value={formData.organisationName}
                onChange={(event) =>
                  setFormData((prev) => ({
                    ...prev,
                    organisationName: event.target.value
                  }))
                }
                disabled={saving}
              />
            </div>
            <div className="mb-3">
              <label className="form-label text-dark">E-Mail</label>
              <input
                type="email"
                className="form-control"
                value={formData.email}
                onChange={(event) =>
                  setFormData((prev) => ({...prev, email: event.target.value}))
                }
                disabled={saving}
              />
            </div>
            <div className="mb-3">
              <label className="form-label text-dark">Straße</label>
              <input
                type="text"
                className="form-control"
                value={formData.street}
                onChange={(event) =>
                  setFormData((prev) => ({...prev, street: event.target.value}))
                }
                disabled={saving}
              />
            </div>
            <div className="mb-3">
              <label className="form-label text-dark">PLZ</label>
              <input
                type="text"
                className="form-control"
                value={formData.zipcode}
                onChange={(event) =>
                  setFormData((prev) => ({...prev, zipcode: event.target.value}))
                }
                disabled={saving}
              />
            </div>
            <div className="mb-3">
              <label className="form-label text-dark">Stadt</label>
              <input
                type="text"
                className="form-control"
                value={formData.city}
                onChange={(event) =>
                  setFormData((prev) => ({...prev, city: event.target.value}))
                }
                disabled={saving}
              />
            </div>
            <div className="mb-3">
              <label className="form-label text-dark">Land</label>
              <input
                type="text"
                className="form-control"
                value={formData.country}
                onChange={(event) =>
                  setFormData((prev) => ({...prev, country: event.target.value}))
                }
                disabled={saving}
              />
            </div>
            <div className="mb-3">
              <label className="form-label text-dark">Bundesland</label>
              <input
                type="text"
                className="form-control"
                value={formData.state}
                onChange={(event) =>
                  setFormData((prev) => ({...prev, state: event.target.value}))
                }
                disabled={saving}
              />
            </div>
            <div className="mb-3">
              <label className="form-label text-dark">Telefon</label>
              <input
                type="text"
                className="form-control"
                value={formData.telephoneNumber}
                onChange={(event) =>
                  setFormData((prev) => ({
                    ...prev,
                    telephoneNumber: event.target.value
                  }))
                }
                disabled={saving}
              />
            </div>
            <button className="btn btn-primary fk-color" type="submit" disabled={saving}>
              Speichern
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
